import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { selectModuleAccess, selectCanalAccess } from '../store/preferencesSlice';
import { getCurrentUser } from '../services/auth';

const ProtectedRoute = ({ children, requiredModule, requiredCanal }) => {
  const hasModuleAccess = useSelector((state) => 
    requiredModule ? selectModuleAccess(state, requiredModule) : true
  );
  
  const hasCanalAccess = useSelector((state) => 
    requiredCanal ? selectCanalAccess(state, requiredCanal) : true
  );

  // Check if user is authenticated
  const currentUser = getCurrentUser();
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Check module and canal access
  if (!hasModuleAccess || !hasCanalAccess) {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
};

export default ProtectedRoute;